import Experience from '@/api/experience'

export default {
  namespaced: true,
  state: {
    experiences: []
  },
  getters: {
  },
  mutations: {
    setExperiences (state, experiences) {
      state.experiences = experiences
    }
  },
  actions: {
    async getExperiences ({ commit }) {
      const experiences = await Experience.get()
      commit('setExperiences', experiences)
    },
    async createExperience ({ commit }, data) {
      await Experience.create(data)
      const experiences = await Experience.get()
      commit('setExperiences', experiences)
    },
    async updateExperience ({ commit }, { data, id }) {
      await Experience.update(id, data)
      const experiences = await Experience.get()
      commit('setExperiences', experiences)
    },
    async deleteExperience ({ commit }, id) {
      await Experience.delete(id)
      const experiences = await Experience.get()
      commit('setExperiences', experiences)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/experience.js